import { render, staticRenderFns } from "./LedRingGroup.vue?vue&type=template&id=4678764b&scoped=true&"
import script from "./LedRingGroup.vue?vue&type=script&lang=js&"
export * from "./LedRingGroup.vue?vue&type=script&lang=js&"
import style0 from "./LedRingGroup.vue?vue&type=style&index=0&id=4678764b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678764b",
  null
  
)

export default component.exports